<template>
    <div class="view-body view-body--module">
      <div class="view-data">
        <div class="button-group button-group--single">
          <button class="button-normal button-normal--media button-normal--searchModule" @click="$emit('upload')">Importuj produkty</button>
        </div>
        <div class="view-data__header view-data__header--module search-header">
          <h1>Wyszukiwarka</h1>
        </div>
        <div class="search-options">
          <div class="form-group">
            <input class="form-control form-control-lg search" type="text" v-model="phrase" @input="searching()"/>
            <img class ="form-group__icon" src="@/assets/symbols/search.svg">
          </div>
          <div class="search-filters">
            <h2>Filtruj</h2>
            <div class="search-filters__body">
              <div class="form-group">
                <label class="checkbox checkbox--search"><input type="checkbox" v-model="filters.number" @change="searching()"/><span class="checkmark"></span> Nr artykułu</label>
                <label class="checkbox checkbox--search"><input type="checkbox" v-model="filters.uslugi" @change="searching()"/><span class="checkmark"></span> Usługi</label>
                <label class="checkbox checkbox--search"><input type="checkbox" v-model="filters.logo" @change="searching()"/><span class="checkmark"></span> Logo</label>
              </div>
              <div class="form-group">
                <label class="checkbox checkbox--search"><input type="checkbox" v-model="filters.name" @change="searching()"/><span class="checkmark"></span> Nazwa produktu</label>
                <label class="checkbox checkbox--search"><input type="checkbox" v-model="filters.icon" @change="searching()"/><span class="checkmark"></span> Ikona</label>
                <label class="checkbox checkbox--search"><input type="checkbox" v-model="filters.prepaid" @change="searching()"/><span class="checkmark"></span> Karty prepaid</label>
              </div>
              <div class="form-group">
                <label class="checkbox checkbox--search"><input type="checkbox" v-model="filters.producer" @change="searching()"/><span class="checkmark"></span> Producent</label>
                <label class="checkbox checkbox--search"><input type="checkbox" v-model="filters.grafika" @change="searching()"/><span class="checkmark"></span> Grafika</label>
                <label class="checkbox checkbox--search"><input type="checkbox" v-model="filters.hero" @change="searching()"/><span class="checkmark"></span> Brand Hero</label>
              </div>
            </div>
          </div>
        </div>
        <div class="view-data__header view-data__header--module">
          <h1>Znaleziono ({{totalRows}})</h1>
        </div>
        <draggable class="search-result" :list="products" group="products">
          <div class="search-item" :class="{'selected' : preparedProduct == product.id}" v-for="product in products" :key="product.id" @click="preparedProduct = product.id">
            <div class="search-item__image">
              <img :src="findMainImage(product)" alt="image" />
            </div>
            <div class="search-item__body">
              <h2>{{product.name}}</h2>
              <p>Nr. Kat: {{product.number}}</p>
            </div>
          </div>
        </draggable>
        <b-pagination
          v-if="this.products.length > 1"
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="7"
          class="search-pagination"
          @change="pageChange">
        </b-pagination>
        <div v-if="products.length > 0"class="button-group button-group--single">
          <button class="button-normal button-normal--media button-normal--searchModule" @click="$emit('addSingle', {id:preparedProduct}); preparedProduct = ''">Dodaj do zlecenia</button>
        </div>
      </div>
  </div>

</template>

<script>

import debounce from "lodash.debounce";
import draggable from 'vuedraggable';

export default {

  name: 'orderSearch',
  components:{

    draggable,

  },
  data () {

    return {

      title: 'Szukaj',

      products: [],

      preparedProduct: '',

      phrase: '',

      filters: {
        number: '',
        name: '',
        producer: '',
        main: '',
        additional: '',
        logo: '',
        icon: '',
        isHero: ''
        },

      /* Table sorting */

      totalRows: 0,
      currentPage: 1,
      perPage: 7,
      offset: 0,

    }

  },
  methods:{

    getProducts(){

      const token = localStorage.getItem('auth_token');

      let search = {
        phrase: this.phrase,
        limit: this.perPage,
        offset: this.offset,
        filters: {},
      };

      const entries = Object.entries(this.filters);

      for (const [key, value] of entries) {
        
        if(value != ''){
          search.filters[key] = 1;
        }

      }

     this.$http.post(`products/ins/orders/searches`, search, {
        headers: {

        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'

        }})
        .then(response => {

          this.products = response.data.list
          this.totalRows = response.data.total

          
        })
        .catch(error =>{

            this.products = [];
            this.totalRows = 1;
            console.error(error.response);

        })

    },

    findMainImage(product){

      product.productImages.forEach(image => {

        if(image.isMain){
          return image.href
        }

      });

    },

    pageChange (page) {

      this.currentPage = page
      this.offset = ((this.currentPage - 1) * this.perPage);
      this.getProducts();
      
    },

    searching: debounce(function(){

      this.getProducts();

    }, 500),

  },
};
</script>

<style lang="scss" scoped>

.view-data__header--module{

  & h1{
    font-weight: 700;
    font-size: 14px;
  }
}

.search-header{
  border-color:#b4b4b4;
}

.button-normal--searchModule{
  font-size: 12px;
  padding: 15px 35px;
  white-space: nowrap;
}

.button-group--single{
  flex-direction: row-reverse;
}

.search-filters{
  display:flex;
  flex-direction: column;
  width:100%;
  position:relative;

  & h2{
    font-size:12px;
  }

  &__body{
    display:flex;
    width:100%;

    & label{
      opacity:1;
      font-weight: 400;
    }

  }
}

.search{
  padding-right: 8%;
}

.checkbox--search{
  margin: 5px 0px;
}

.search-item{
  display:flex;
  justify-content: space-between;
  width:100%;
  border:1px #000 solid;
  margin:10px 0px;
  padding: 5px;
  cursor:move;

  &.selected{
    background: rgba(46,204,113,0.14);
    border: 2px solid #2ECC71;
  }

  &__image{
    position:relative;
    width: 60px;
    height: 60px;
    border:1px red solid;

    & img {
      display:block;
      position:absolute;
      top:0;
      left:0;
      width:100%;
      height:100%;
    }
  }

  &__body{
    width:85%;

    & h2{
      font-size: 12px;
    }

    & p{
      font-size: 8px;
    }
  }
}

.search-pagination{
  justify-content: center;
}

</style>